import { Message } from "@/app/store/types";
import React from "react";
import styles from "./File.module.scss";
import { parseFileData } from "@/app/utils/file";
import SvgFile from "@/app/icons/SvgFile.svg";
import { getHandyAppVersion, isHandyApp } from "@/app/utils/device";
import { copyToClipboard } from "@/app/utils/string";
import Locale from "@/app/locales";
import { Toast } from "@douyinfe/semi-ui";
import { openBrowser } from "@/app/utils/handyBridge";
import { isValidUrl } from "@/app/utils/url";

export default function File({ msg }: { msg: Message }) {
  const content = msg.content as string;
  const openFile = async () => {
    const fileUrl = parseFileData(content)?.fileUrl;
    if (!isValidUrl(fileUrl)) {
      return;
    }
    if (isHandyApp()) {
      const handyVersion = getHandyAppVersion();
      if (
        handyVersion &&
        !!Number(handyVersion) &&
        Number(handyVersion) >= 5140 &&
        window.wx &&
        typeof window.wx.postMessage === "function"
      ) {
        openBrowser(fileUrl);
        return;
      }
      await copyToClipboard(fileUrl);
      Toast.success(Locale.tips.copyFileSuccess);
      return;
    }
    window.open(parseFileData(content)?.fileUrl);
  };
  return (
    <div
      onClick={openFile}
      className={`${styles.fileBox} ${msg.id ? styles.success : styles.error}`}
    >
      <span>{parseFileData(content)?.fileName}</span> <SvgFile />
    </div>
  );
}
